import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

let players = {
    1: "https://zequencer.mypinata.cloud/ipfs/QmYErgGMEmZLnnP1vAvMKQNMVTPqKJh2WiLETujZXDS2HR/",
    2: "https://zequencer.mypinata.cloud/ipfs/QmeGU4SzFDPdkv38kwAqWZFSXjiwaw4yb6DaNgmRax56P2/",
    3: "https://zequencer.mypinata.cloud/ipfs/QmRYo8dbhz2RsoPHATi2FL81hXoziT2R6zzxHSRhQbHn3S/"
};
const StemPlayer = ({tokenId}) => { 

    return (<iframe sandbox="allow-scripts allow-same-origin"
                    height="600"
                    width="400"
                    aria-describedby="spore"
                    alt="spore.vision"
                    src={players[tokenId]}
                    className="zora-mediaObject css-hnzuw7 zora-mediaObject--mediaLoaded zora-mediaObject--isFullPage"
                    style={{borderWidth: "0px"}}>
            </iframe>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StemPlayer);
